import { render, staticRenderFns } from "./PaymentScheduleSection.vue?vue&type=template&id=08552c3c&scoped=true"
import script from "./PaymentScheduleSection.vue?vue&type=script&lang=ts"
export * from "./PaymentScheduleSection.vue?vue&type=script&lang=ts"
import style0 from "./PaymentScheduleSection.vue?vue&type=style&index=0&id=08552c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08552c3c",
  null
  
)

export default component.exports